import { clsx } from 'clsx';
import { type FC, type ReactNode } from 'react';

import { LayoutBlock } from '../LayoutBlock';
import { type IVerticalArrowProps } from '../VerticalArrow';
import { VerticalSlider } from '../VerticalSlider';

import styles from './SliderBlock.css';

type TSliderBlockProps = {
  children: ReactNode[];
  title: string;
  sourceLabel?: string;
  sourceTooltip?: ReactNode;
  rightAdornment?: ReactNode;
  description?: string;
  arrow?: FC<IVerticalArrowProps>;
  sliderKey?: string;
  /** @default 24 */
  contentOffset?: 24 | null;
  id: string;
  onShow: () => void;
};

export const SliderBlock: FC<TSliderBlockProps> = ({
  id,
  children,
  title,
  sourceLabel,
  sourceTooltip,
  description,
  rightAdornment,
  arrow,
  onShow,
  sliderKey,
  contentOffset = 24,
}) => {
  return (
    <LayoutBlock
      contentOffset={contentOffset ? contentOffset : undefined}
      description={description}
      id={id}
      rightAdornment={rightAdornment}
      semiTitle={sourceLabel ? { hint: sourceTooltip, title: sourceLabel } : undefined}
      title={title}
      onView={onShow}
    >
      <div className={styles['slider']}>
        <VerticalSlider
          arrow={arrow || ((): null => null)}
          containerClass={clsx(styles['slider-list'], arrow && styles['slider-list-overflow--hidden'])}
          key={sliderKey}
        >
          {children}
        </VerticalSlider>
      </div>
    </LayoutBlock>
  );
};
